import React from "react";

export default function Image(props) {
  const isSpecialHissenetSlide =
    props.slide.section === "hissenet-projeler" &&
    (props.slide.id === 3 || props.slide.id === 4);

  return (
    <div className="flex flex-col items-center mx-auto gap-4 relative w-[90%] sm:w-[480px] sm:h-[290px]">
      <div className="font-semibold text-lg">{props.slide.name}</div>
      <img src={props.slide.image} className="h-auto sm:h-full" />
      {props.slide.category && (
        <div
          className={`absolute ${
            isSpecialHissenetSlide
              ? "left-1/2 transform -translate-x-1/2"
              : "-right-3 sm:-right-6"
          } -bottom-8 scale-75 sm:scale-100 sm:-bottom-8 bg-[#fb968f] min-w-44 pl-4 pr-16 w-auto h-12 text-white text-md flex justify-center items-center rounded-3xl`}
        >
          {props.slide.category}
          <div className="absolute -right-4 top-1/2 transform -translate-y-1/2 bg-[#fb968f] w-16 h-16 rounded-full flex justify-center items-center">
            <img
              src="https://srv-cdn.onedio.com/store/c012124bfed751134089144ecb8cccb22d318d05a796da5e152634a569ebc31b.png"
              className="w-4 h-4"
              loading="lazy"
              alt="icon"
            />
          </div>
        </div>
      )}
    </div>
  );
}
